import type { ReactNode } from 'react';

/**
 * A profile link that needs a signed-in viewer. The same words for every slug that is not
 * public, so the prompt never says whether a page is hidden, Labs-only, or missing (KTD4).
 * `action` is the sign-in control; signing in returns to this link (`auth-config.ts`).
 */
export function SignInPrompt({ action }: { action?: ReactNode }) {
  return <section className="notice">
    <h2>Sign in to see this page</h2>
    <p>Some 240 Profile pages open only for teachers signed in to 240 Labs. Sign in and you will come straight back here.</p>
    {action && <div className="sign-in-controls">{action}</div>}
  </section>;
}
